
export default function Benefits() {
  const childBenefits = [
    'Fluência em Inglês',
    'Cognição Acelerada',
    'Pensamento Criativo',
    'Habilidades Sociais',
    'Amor pelo Aprender'
  ];

  const familyBenefits = [
    'Tranquilidade e Segurança',
    'Investimento no Futuro',
    'Parceria Ativa',
    'Comunidade de Apoio'
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-red-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-6">
            Benefícios para a criança e para a família
          </h2>
          <p className="text-lg md:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
            Na The Joy School Paulínia, investimos no presente para construir um futuro brilhante. Veja o que seu filho e sua família ganharão ao fazer parte da nossa comunidade:
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-3xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-6 flex items-center gap-3">
                <i className="ri-user-smile-line text-3xl"></i>
                Para a Criança
              </h3>
              <ul className="space-y-4">
                {childBenefits.map((benefit, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-green-500 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-gray-800 font-medium">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-3xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-red-900 mb-6 flex items-center gap-3">
                <i className="ri-parent-line text-3xl"></i>
                Para a Família
              </h3>
              <ul className="space-y-4">
                {familyBenefits.map((benefit, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-slate-600 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-gray-800 font-medium">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-red-200 to-red-300 rounded-3xl transform rotate-3"></div>
            <img 
              src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/bde454667f9e35e50d893a878aea1e33.jpeg"
              alt="Criança feliz na The Joy School Paulínia"
              className="relative rounded-3xl shadow-2xl w-full h-auto object-cover object-top"
            />
          </div>
        </div>

        <div className="text-center mt-12">
          <div className="mb-8">
            <img 
              src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/30da61e4e91f8cdfba1f466b06c78cd0.png"
              alt="Atividade extracurricular - The Joy School Paulínia"
              className="w-full h-auto mx-auto"
            />
          </div>
          <a 
            href="https://wa.me/5519989250972?text=Olá,%20vi%20o%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20a%20The%20Joy%20School%20Paulínia."
            className="inline-block bg-gradient-to-r from-red-500 to-red-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:from-red-600 hover:to-red-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Fale com a The Joy
          </a>
        </div>
      </div>
    </section>
  );
}
